import Bezier from "bezier-js";
import {
  STAGE_LABELS,
  STAGE_LAUNCH,
  STAGE_MOMENTUM_GROWTH,
  STAGE_STRATEGIC_GROWTH,
  STAGE_SUSTAINABLE_HEALTH,
  STAGE_MAINTENANCE,
  STAGE_PRESERVATION,
  STAGE_LIFE_SUPPORT,
} from "./../constants";

export const getBaseForStage = (stage) => {
  switch (Number(stage)) {
    case STAGE_LAUNCH:
      return 0;
    case STAGE_MOMENTUM_GROWTH:
      return 35;
    case STAGE_STRATEGIC_GROWTH:
      return 61.25;
    case STAGE_SUSTAINABLE_HEALTH:
      return 70;
    case STAGE_MAINTENANCE:
      return 61.25;
    case STAGE_PRESERVATION:
      return 35;
    case STAGE_LIFE_SUPPORT:
      return 0;
    default:
      return;
  }
};

export const getLabelForStage = (stage) => {
  return STAGE_LABELS[stage];
};

export const getStageForIndex = (index) => {
  return Math.floor(index / 7);
};

export const getAverageForStage = (sortedQuestions, stage) => {
  return (
    sortedQuestions
      .filter((value, index) => getStageForIndex(index) === stage)
      .reduce((sum, value) => (sum += value)) / 7
  );
};

export const getStageIndex = (topStage) => {
  return 7 * topStage.stage + 3;
};

export const getTopStage = (sortedQuestions, side) => {
  let favorSide = side;
  const stages = sortedQuestions.slice(0, 49).reduce((data, value, index) => {
    const stage = getStageForIndex(index);
    if (data[stage]) {
      data[stage].value += value || 0;
    } else {
      data.push({ stage, value });
    }
    return data;
  }, []);
  let stagesForSide = [];
  if (favorSide === "left") {
    stagesForSide = stages.slice(0, 4);
  } else if (favorSide === "right") {
    stagesForSide = stages.slice(4);
  } else {
    stagesForSide = stages.slice(0);
  }
  return stagesForSide.sort((a, b) => b.value - a.value)[0];
};

export const getChartData = (sortedQuestions, selectedIndex) => {
  const chartQuestions = sortedQuestions.slice(0, 49);
  const baseCurve = new Bezier(0, 0, 3, 12, 6, 0);
  const basePoints = baseCurve.getLUT(chartQuestions.length);
  return chartQuestions.map((value, index) => {
    const base = basePoints[index].y;
    const stage = getStageForIndex(index);
    const label = getLabelForStage(stage);
    const average = getAverageForStage(sortedQuestions, stage);
    const selector = index === 0 || index === 48 || index === stage * 7;
    const score = selector ? average : null;
    const phase = index <= selectedIndex ? base : null;
    return { base, stage, label, value, average, score, phase };
  });
};



// WEBPACK FOOTER //
// ./src/assess/survey-utils.js